import axiosRequest from "@/api/axios-optimize"

// 判断字典是否存在
export function judgeExist(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/skuValue/judgeExist`, data, config)
}

// 获取字典列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/skuValue`, { params: data, ...config})
}

// 获取字典详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/skuValue/${data.id}`, { params: {}, ...config})
}

// 更新字典
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/product/skuValue/${data.skuValueId}`, data, config)
}

// 新增字典
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/skuValue`, data, config)
}

// 删除字典
export function deleteItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/skuValue/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 批量删除字典
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/skuValue/batchDelete`, { data, ...config})
}

// 改变字典状态
export function changeStatus(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/skuValue/changeStatus`, data, config)
}

// 字典管理相关接口 结束